import dayjs from "dayjs"

import type { ProductVersionInfo } from "@/graphql/codegen/graphql"
import { ProductVersionStatus } from "@/graphql/codegen/graphql"

export const groupByStatus = (
  data: ProductVersionInfo[],
  skipDraft = false
): Map<ProductVersionStatus, ProductVersionInfo[]> => {
  const grouped = new Map<ProductVersionStatus, ProductVersionInfo[]>()

  data.forEach((item) => {
    if (skipDraft && item.status === ProductVersionStatus.Draft) {
      return
    }

    if (!grouped.has(item.status)) {
      grouped.set(item.status, [])
    }

    grouped.get(item.status)!.push(item)
  })

  grouped.forEach((items) => {
    items.sort((a, b) => dayjs(b.releaseDate).diff(dayjs(a.releaseDate)))
  })

  return grouped
}

export const getVersionStatusColor = (status?: ProductVersionStatus): string => {
  switch (status) {
    case ProductVersionStatus.Past:
      return "bg-red-300"
    case ProductVersionStatus.Draft:
      return "bg-yellow-300"
    default:
      return "bg-green-300"
  }
}
